import { useTranslation } from "react-i18next";
import { Flex } from "antd";

import { Button } from "@av/components/atoms/Button";
import { useCompanyKnowledgeStyles } from "../styles";

type ModalActionsProps = {
  cancelTestIdPrefix: string;
  isSaving?: boolean;
  okText: string;
  okTestIdPrefix: string;
  onCancel: () => void;
};

export function ModalActions({
  cancelTestIdPrefix,
  isSaving,
  okText,
  okTestIdPrefix,
  onCancel,
}: ModalActionsProps) {
  const { t } = useTranslation();
  const { styles } = useCompanyKnowledgeStyles();

  return (
    <Flex className={styles.modalActions} gap={8} justify="flex-end">
      <Button onClick={onCancel} testIdPrefix={cancelTestIdPrefix} type="link">
        {t("platform.adminSettings.companyKnowledge_cancel")}
      </Button>
      <Button htmlType="submit" loading={isSaving} testIdPrefix={okTestIdPrefix} type="primary">
        {okText}
      </Button>
    </Flex>
  );
}
